export const LOCAL_MOCK_SAMPLE_CLASS_ID = "idLocalMockSampleClass";
export const LOCAL_MOCK_SAMPLE_ONBOARDING_BOX_ID = "localMockSampleOnboardingBox";
export const LOCAL_MOCK_SAMPLE_RECORDINGS_BOX_ID = "localMockSampleRecordingsBox";
